export const moduleType = {
  CUSTOM: 'custom',
  GENERAL: 'general',
  ADVERTISER: 'advertiser',
}

export const moduleOptions = [
  {
    label: 'Mindworks-定制',
    value: moduleType.CUSTOM,
  },
  {
    label: 'Mindworks-playturbo订阅',
    value: moduleType.GENERAL,
  },
  {
    label: 'Mindworks-playturbo月耗',
    value: moduleType.ADVERTISER,
  },
]

export const statusOptions = [
  {
    label: '草稿',
    value: 'draft',
  },
  {
    label: '已出账',
    value: 'success',
  },
  {
    label: '待业务审批',
    value: 'pending',
  },
  {
    label: '出账失败',
    value: 'failed',
  },
]
